<script>
	export default {
		name: 'IpcExecuter',
		methods: {
			ipcEditPassword(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getUserByUid(uid)
					}).then(result => {
						const body_ = {
							point: {
								username: result.username,
								password: uid,
								modified_by_username: 'boapi',
								api_id: 1
							}
						}
						// custom bri life start
						// return self_.$_ipcExec_callFunction('postEditPassword' , body_)
						
						const securityGroup_ = self_.getUserState('securityGroupCode')
						body_.securityGroup = securityGroup_;

						body_.env = self_.env;

						return self_.callFunction('customBriLifeIpcFunction', 'postEditPassword' , { body: body_ })
						// custom bri life end
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipcRegisterUser(username, password, email, phone, fullName) {
				const self_ = this;

				const body_ = {
					point: {
						username: username,
						password: password,
						user_fullname: fullName,
						user_email: email,
						user_phone: phone,
						user_status_id: '0',
						user_group_code: 'user',
						registered_by_username: 'boapi',
						api_id: '0'
					}
				}
				// custom bri life start
				// return self_.$_ipcExec_callFunction('postRegisterUser' , body_)

				const securityGroup_ = self_.getUserState('securityGroupCode')
				body_.securityGroup = securityGroup_;

				if(securityGroup_ == 'adminibs') { body_.point.user_group_code = 'ibs' }
				if(securityGroup_ == 'adminagency') { body_.point.user_group_code = 'agc' }
				if(securityGroup_ == 'test') { body_.point.user_group_code = 'test' }

				// body_.env = self_.env;

				return self_.callFunction('customBriLifeIpcFunction', 'postRegisterUser' , { body: body_ })
				// custom bri life end
			},
			ipcGetClients(subdomain) {
				const self_ = this;
				let body_ = {}
				if(!self_.isFalse(subdomain)) {
					body_ = { subdomain: subdomain }
				}
				return self_.$_ipcExec_callFunction('getClients', body_)
			},
			ipcGetClientUsers(username) {
				const self_ = this;
				let body_ = {}
				if(!self_.isFalse(username)) {
					// custom bri life start
					const securityGroup_ = self_.getUserState('securityGroupCode')
					// ibs
					if(securityGroup_ == 'adminibs' || securityGroup_ == 'ibs') {
						body_ = { username: username + '_' + self_.ipcDomain + '-ibs' }
					}
					// agency
					else if(securityGroup_ == 'adminagency' || securityGroup_ == 'agency') {
						body_ = { username: username + '_' + self_.ipcDomain + '-agency' }
					}
					// test
					else if(securityGroup_ == 'test') {
						body_ = { username: username + '_' + self_.ipcDomain + '-test' }
					}
					// my life
					else {
						body_ = { username: username + '_' + self_.ipcDomain }	
					}
					// custom bri life end
				}
				return self_.$_ipcExec_callFunction('getClientUsers', body_)
			},
			ipcGetGroups(code) {
				const self_ = this;
				let body_ = {}
				if(!self_.isFalse(code)) {
					body_ = { code: code + '_' + self_.ipcDomain }
				}
				return self_.$_ipcExec_callFunction('getGroups', body_)
			},
			ipcGetItemOrders(clientUserId) {
				const self_ = this;
				let body_ = {}
				if(!self_.isFalse(clientUserId)) {
					body_ = { clientUserId: clientUserId }
				}
				return self_.$_ipcExec_callFunction('getItemOrders', body_)
			},
			ipcGetPointCriterias(code) {
				const self_ = this;
				let body_ = {}
				if(!self_.isFalse(code)) {
					body_ = { code: code }
				}
				return self_.$_ipcExec_callFunction('getPointCriterias', body_)
			},
			ipcStorePointGiving(clientUserId, groupCode, criteriumCode, promoCode, pointGiven, authorizeDate, expiredDate) {
				const self_ = this;

				let userId_ = null;
				let boapiId_ = null;
				let groupId_ = null;
				let criteriumId_ = null;
				let criteriumName_ = null;
				let promoId_ = null;

				const getBoapiId_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipcGetClientUsers('boapi')
						}).then(result => {
							boapiId_ = result[0].id;
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const getGroupId_ = groupCode => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipcGetGroups(groupCode)
						}).then(result => {
							groupId_ = result[0].id;
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const getCriterium_ = criteriumCode => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipcGetPointCriterias(criteriumCode)
						}).then(result => {
							criteriumId_ = result[0].id;
							criteriumName_ = result[0].name;
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const getPromoId_ = promocode => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipcGetPromos(promoCode)
						}).then(result => {
							promoId_ = result[0].id;
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				let promiseArray_ = []
				promiseArray_.push(getBoapiId_())
				promiseArray_.push(getGroupId_(groupCode))
				promiseArray_.push(getCriterium_(criteriumCode))
				promiseArray_.push(getPromoId_(promoCode))

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return Promise.all(promiseArray_)
					}).then(() => {
						const today_ = self_.formatDate(new Date(), 'YYYY-MM-DD hh:mm:ss')

						const body_ = {
							groupId: groupId_,
							pointCriteriaId: criteriumId_,
							promoId: promoId_,
							itemOrderId: 0,
							pointCriteriaName: criteriumName_,
							pointGiven: pointGiven,
							pointRemaining: pointGiven,
							authorizeDate: authorizeDate,
							expiredDate: expiredDate,
							pointStatusId: 3,
							clientUserId: clientUserId,
							givenBy: boapiId_,
							pointRead: 0,
							expiredRead: 0,
							cancelRead: 0,
							isPreviouslyApproved: 0,
							created: today_,
							modified: today_
						}
						return self_.$_ipcExec_callFunction('postPointGiving', body_)
					}).then(res => {
						resolve(res)
					}).catch(err => {
						reject(err)
					})
				})
			},
			ipcGetPointGiving(clientUserId) {
				const self_ = this;
				let body_ = {}
				if(!self_.isFalse(clientUserId)) {
					body_ = { clientUserId: clientUserId }
				}
				return self_.$_ipcExec_callFunction('getPointGiving', body_)
			},
			ipcStorePromos(clientSubDomain, name, promoCode, bonusPoint, startDate, endDate) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipcGetClients(clientSubDomain)
					}).then(result => {
						const clientId_ = result[0].id;

						const body_ = {
							clientId: clientId_,
							name: name,
							promoCode: promoCode,
							bonusPoint: bonusPoint,
							startDate: startDate,
							endDate: endDate,
							description: null,
							deleted: 0
						}

						return self_.$_ipcExec_callFunction('postPromos', body_)
					}).then(result => {
						resolve(result)
					}).catch(error => {
						reject(error)
					})
				})

			},
			ipcGetPromos(promoCode) {
				const self_ = this;
				let body_ = {}
				if(!self_.isFalse(promoCode)) {
					body_ = { promoCode: promoCode }
				}
				return self_.$_ipcExec_callFunction('getPromos', body_)
			},
			ipcStorePromoCodesIds(promosId, promoCodeStatusId) {
				const self_ = this;

				const body_ = {
					promosId: promosId,
					promoCodeStatusId: promoCodeStatusId
				}
				return self_.$_ipcExec_callFunction('postPromoCodesIds', body_)
			},
			ipcGetPromoCodesIds(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipcExec_callFunction('getPromoCodesIds', body_)
			},
			ipcUpdatePromoCodesIds(promoCodeId, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipcExec_callFunctionById('putPromoCodesIds', promoCodeId, body)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipcStorePromoGroupPromoCodes(promoGroupId, promoCodeId) {
				const self_ = this;

				const body_ = {
					promoGroupId: promoGroupId,
					promoCodeId: promoCodeId
				}
				return self_.$_ipcExec_callFunction('postPromoGroupPromoCodes', body_)
			},
			$_ipcExec_callFunction(apiName, body) {
				const self_ = this;

				body.env = self_.env;

				return self_.callFunction('ipcFunction', apiName, { body: body })
			},
			$_ipcExec_callFunctionById(apiName, id, body) {
				const self_ = this;

				body.env = self_.env;

				return self_.callFunction('ipcFunction', apiName, { id: id, body: body })
			}
		}
	}
</script>